module.exports = __webpack_public_path__ + "img/identity-card-a.e710a084.png";